module.exports = __webpack_public_path__ + "img/scada.png";